import React, { useState } from "react";
import logoiii from "../assets/logoiii.png";
import Swal from 'sweetalert2';
import axios from "axios";

const Recomendaciones = () => {
  const [contentType, setContentType] = useState("");
  const [favoriteContent, setFavoriteContent] = useState("");
  const [suggestions, setSuggestions] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Enviar datos al backend
      const response = await axios.post(`${API_URL}/api/v1/recommendations`, {
        contentType,
        favoriteContent,
        suggestions
      });
      
      console.log("Respuesta del servidor:", response.data);
      
      await Swal.fire({
        title: '¡Gracias por tu feedback!',
        text: 'Tu opinión es muy importante para nosotros',
        icon: 'success',
        confirmButtonText: 'Aceptar',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
        background: '#1e293b',
        color: '#f8f9f9',
      });
      
      // Reiniciar formulario
      setContentType("");
      setFavoriteContent("");
      setSuggestions("");
    } catch (error) {
      console.error("Error al enviar recomendación:", error);
      
      await Swal.fire({
        title: 'Ha ocurrido un error',
        text: 'No pudimos procesar tu recomendación. Por favor, intenta de nuevo más tarde.',
        icon: 'error',
        confirmButtonText: 'Aceptar',
        background: '#1e293b',
        color: '#f8f9f9',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="min-h-screen bg-gradient-to-b from-black to-[#0f172a] flex flex-col items-center justify-center px-4 py-16">
      {/* Header con efecto de glassmorphism */}
      <header className="fixed top-0 left-0 w-full backdrop-blur-md bg-black/70 z-10 border-b border-yellow-500/20 shadow-lg shadow-yellow-500/5">
        <div className="container mx-auto flex items-center justify-between py-3 px-6">
          <div className="flex items-center space-x-3">
            <img src={logoiii} alt="Logo de Epic Movie" className="w-10 h-10 animate-pulse" />
            <h1 className="text-yellow-400 text-xl font-bold font-montserrat tracking-wider">
              EPIC MOVIE
            </h1>
          </div>
        </div>
      </header>

      {/* Contenedor principal con efecto de neomorfismo */}
      <div className="max-w-2xl w-full mx-auto bg-gradient-to-br from-[#1e293b] to-[#0f172a] rounded-3xl overflow-hidden shadow-[0_8px_32px_0_rgba(31,38,135,0.37)] backdrop-blur-sm border border-white/5 p-1">
        <div className="bg-[#111827]/40 backdrop-blur-sm rounded-3xl p-8 md:p-10">
          {/* Encabezado con efecto de texto brillante */}
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-500 mb-2">
              RECOMENDACIONES Y FEEDBACK
            </h2>
            <p className="text-yellow-100/60 text-sm">
              Ayúdanos a mejorar tu experiencia en Epic Movie
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Tipo de contenido */}
            <div className="group">
              <label className="block text-yellow-100 text-lg font-medium mb-3 transition-all duration-300 group-focus-within:text-yellow-400">
                ¿Qué tipo de contenido te gustaría ver más?
              </label>
              <div className="relative">
                <select
                  value={contentType}
                  onChange={(e) => setContentType(e.target.value)}
                  className="w-full p-4 rounded-xl bg-[#0f172a]/80 text-white border border-yellow-500/30 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-500/40 focus:outline-none transition-all duration-300 backdrop-blur-sm placeholder-gray-400"
                  required
                  disabled={isSubmitting}
                >
                  <option value="" disabled>
                    Selecciona una opción
                  </option>
                  <option value="peliculas">Películas</option>
                  <option value="series">Series</option>
                  <option value="anime">Anime</option>
                  <option value="documentales">Documentales</option>
                  <option value="otros">Otros</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none">
                  <svg className="h-5 w-5 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Película o serie favorita */}
            <div className="group">
              <label className="block text-yellow-100 text-lg font-medium mb-3 transition-all duration-300 group-focus-within:text-yellow-400">
                ¿Cuál es tu película o serie favorita que quisieras en nuestra plataforma?
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={favoriteContent}
                  onChange={(e) => setFavoriteContent(e.target.value)}
                  className="w-full p-4 rounded-xl bg-[#0f172a]/80 text-white border border-yellow-500/30 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-500/40 focus:outline-none transition-all duration-300 backdrop-blur-sm placeholder-gray-400"
                  placeholder="Ej: El Señor de los Anillos"
                  required
                  disabled={isSubmitting}
                />
                <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none">
                  <svg className="h-5 w-5 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 14a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 5.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V5.477L6.237 6.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 14a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Sugerencias */}
            <div className="group">
              <label className="block text-yellow-100 text-lg font-medium mb-3 transition-all duration-300 group-focus-within:text-yellow-400">
                Déjanos tus sugerencias o comentarios
              </label>
              <div className="relative">
                <textarea
                  value={suggestions}
                  onChange={(e) => setSuggestions(e.target.value)}
                  className="w-full p-4 rounded-xl bg-[#0f172a]/80 text-white border border-yellow-500/30 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-500/40 focus:outline-none transition-all duration-300 backdrop-blur-sm placeholder-gray-400"
                  rows="5"
                  placeholder="Escribe aquí tus ideas y comentarios para mejorar nuestra plataforma..."
                  required
                  disabled={isSubmitting}
                />
                <div className="absolute top-4 right-4 pointer-events-none">
                  <svg className="h-5 w-5 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Botón de envío */}
            <div className="text-center pt-4">
              <button
                type="submit"
                className="px-8 py-3 rounded-xl bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-bold text-lg shadow-lg shadow-yellow-500/30 hover:shadow-yellow-500/50 transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-yellow-500/50"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Enviando...
                  </span>
                ) : (
                  "Enviar Feedback"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="fixed top-1/4 left-10 w-24 h-24 rounded-full bg-yellow-500/10 blur-3xl pointer-events-none"></div>
      <div className="fixed bottom-1/4 right-10 w-32 h-32 rounded-full bg-yellow-500/5 blur-3xl pointer-events-none"></div>
    </section>
  );
};

export default Recomendaciones;
